import { useForm } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function OrganizationsNew({ errors: serverErrors = {} }) {
  const { data, setData, post, processing, errors } = useForm({ name: '' })
  const allErrors = { ...serverErrors, ...errors }

  function handleSubmit(e) {
    e.preventDefault()
    post('/organization')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">Gosellgo</h1>
          <p className="mt-2 text-gray-600">Konfigurera din organisation</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Organisationsnamn" error={allErrors.name}>
              <input
                type="text"
                value={data.name}
                onChange={e => setData('name', e.target.value)}
                placeholder="e.g. Fotbollsklubben IF"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <Button type="submit" disabled={processing} className="w-full">
              {processing ? 'Skapar…' : 'Skapa organisation'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
